import React, { useRef } from "react";
import CustomCard from "../Card";
import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const MapComponent: React.FC = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstance = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || mapInstance.current) return;

    const map = L.map(mapRef.current).setView([25.276987, 55.296249], 11);
    mapInstance.current = map;

    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      {
        attribution: "&copy; OpenStreetMap contributors & CartoDB",
      }
    ).addTo(map);

    const locations: {
      name: string;
      coords: [number, number];
      color: string;
      size: number;
    }[] = [
      {
        name: "Deira",
        coords: [25.3, 55.3] as [number, number],
        color: "#1F5782",
        size: 50,
      },
      {
        name: "Bur Dubai",
        coords: [25.2, 55.27] as [number, number],
        color: "#E57373",
        size: 40,
      },
      {
        name: "Al Barsha",
        coords: [25.1, 55.24] as [number, number],
        color: "#FFC107",
        size: 30,
      },
      {
        name: "Al Warqa'a",
        coords: [25.15, 55.4] as [number, number],
        color: "#388E3C",
        size: 20,
      },
    ];

    locations.forEach((loc) => {
      L.circle(loc.coords, {
        color: loc.color,
        fillColor: loc.color,
        fillOpacity: 0.5,
        radius: loc.size * 50,
      })
        .addTo(map)
        .bindPopup(`<b>${loc.name}</b>`);
    });

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={mapRef}
      style={{ minHeight: "445px", width: "100%", borderRadius: "15px" }}
    />
  );
};

const Location: React.FC = React.memo(() => {
  return (
    <CustomCard heading="CASE /" subHeading="LOCATION">
      <MapComponent />
    </CustomCard>
  );
});

export default Location;
